import { Cargo } from "./cargo.model";
import { Eleicao } from "./eleicao.model";
export class CandidatosCsvDTO{
    constructor(
        public nome?: string,
        public cargo?: Cargo,
        public cpf?: string,
        public curriculum?: string,
        public eleicaoId?: Eleicao,
        public parametroJustificativa?: string,
        public votoJustificavel?: boolean,
    ){}
}